/**
 * @typedef {Object} ToothMatrixDO
 * @property {string} toothGumType - The type of tooth gum (UPPER or LOWER)
 * @property {number} stageNumber - The stage number
 * @property {Matrix4[]} toothMatrixList - The tooth matrix list
 */

import {
  TOOTH_GUM_TYPE_KEY,
  TOOTH_STAGE_NUMBER_KEY,
} from "../constant/toothConstant";

/**
 * @type {ToothMatrixDO[]}
 */
const toothMatrixDOListSingle = [];
const toothMatrixDOMapSingle = {};

const addToothMatrixDO = (toothMatrixDO) => {
  toothMatrixDOListSingle.push(toothMatrixDO);
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${toothMatrixDO.stageNumber}.${TOOTH_GUM_TYPE_KEY}:${toothMatrixDO.toothGumType}`;
  toothMatrixDOMapSingle[key] = toothMatrixDO;
};

const getToothMatrixDOList = () => {
  return toothMatrixDOListSingle;
};

const getToothMatrixDOByStageNumberAndToothGumType = (
  stageNumber,
  toothGumType
) => {
  const key = `${TOOTH_STAGE_NUMBER_KEY}:${stageNumber}.${TOOTH_GUM_TYPE_KEY}:${toothGumType}`;

  const toothMatrixDO = toothMatrixDOMapSingle[key];
  return toothMatrixDO;

  // if (toothMatrixDO) {
  //   return null;
  // }

  // return toothMatrixDO.toothMatrixList[toothIndex - 1];
};

const getToothMatrixDOByStageNumberAndToothGumTypeAndToothIndex = (
  stageNumber,
  toothGumType,
  toothIndex
) => {
  const toothMatrixDO = getToothMatrixDOByStageNumberAndToothGumType(
    stageNumber,
    toothGumType
  );

  if (!toothMatrixDO) {
    return null;
  }

  return toothMatrixDO.toothMatrixList[toothIndex - 1];
};

export default {
  addToothMatrixDO,
  getToothMatrixDOList,
  getToothMatrixDOByStageNumberAndToothGumType,
  getToothMatrixDOByStageNumberAndToothGumTypeAndToothIndex,
};
